import { GroupClaimSubmissionService } from './../../service/group-claim-submission/group-claim-submission.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { OnlineDocumentUploadComponent } from '../online-document-upload/online-document-upload.component';
import { OnlineGenerateInputComponent } from '../online-generate-input/online-generate-input.component';

@Component({
  selector: 'app-online-claim-submission',
  templateUrl: './online-claim-submission.component.html',
  styleUrls: ['./online-claim-submission.component.scss']
})
export class OnlineClaimSubmissionComponent implements OnInit {
  selectedTab = 0;
  resetDocuments: Boolean = true;
  isParentTabSelectionChange: Boolean = false;
  tabs = [];
  dataRequiredForDocumentUpload: any;
  dataRequiredForGeneratingInput: any;
  private browserId: string;
  private requestToken: string;
  enrolId : number = null;
  previousDataOfGeneratingInput:any;

  @Input() set resetOnlineSubmissionTab(value) {
    if (value) {
      this.setActiveTab(0);
      this.isParentTabSelectionChange = true;
      this.resetOnlineSubmissionTabValue.emit();
    }
  }
  @Output() resetOnlineSubmissionTabValue = new EventEmitter<any>();

  @ViewChild(OnlineGenerateInputComponent, { static: true }) onlineGenerateInputComponent: OnlineGenerateInputComponent;
  @ViewChild(OnlineDocumentUploadComponent, { static: true }) onlineDocumentUploadComponent: OnlineDocumentUploadComponent;

  constructor(private groupClaimSubmissionService: GroupClaimSubmissionService) { }

  ngOnInit() {
    this.resetTabsToInitialStage();
    this.resetData();
    //this.getClaimSubmissionRequiredData();
  }

  resetTabsToInitialStage(){
    this.tabs = [
      {
        name: "Validate Enrollee Data",
        disabled: false,
        icon: '../assets/img/validate-enrol-data.svg'
      },
      {
        name: "Generate Input",
        disabled: true,
        icon: '../assets/img/user.svg'
      },
      {
        name: "Document Upload",
        disabled: true,
        icon: '../assets/img/document-upload.svg'
      },
      {
        name: "View My Details",
        disabled: true,
        icon: '../assets/img/view-my-details.svg'
      }
    ];
  }

  setActiveTab(tabIndex: number) {
    this.tabs[tabIndex].disabled = false;
  }

  setInActiveTab(tabIndex: number) {
    this.tabs[tabIndex].disabled = true;
  }

  validOTP(data: any) {
    if (data) {
      this.dataRequiredForGeneratingInput = data;
      this.browserId = data.browserId;
      this.requestToken = data.requestToken;
      this.enrolId = data.enrolId;
      this.setInActiveTab(0);
      this.navigateToTab(1)
      this.setActiveTab(3);
    }
  }

  //eb dashboard v1
  // getClaimSubmissionRequiredData(){
  //   this.groupClaimSubmissionService.getClaimSubmissionRequiredData().subscribe(
  //     (res:any) => {
  //       this.dataRequiredForGeneratingInput = {
  //           relationList: res.relations,
  //           productList: res.enrolproducts,
  //           dependentProducts: res.dependentProducts,
  //           insuredName: res.insureName,
  //           browserId: this.browserId,
  //           groupPolicyNo: res.groupPolicyNumber,
  //           groupPolicyName: res.groupPolicyName,
  //           certificateNo: res.certificateNo,
  //           birthYear: res.birthYear,
  //           enrolId: res.enrolId,
  //           requestToken: this.requestToken
  //         }
  //     }
  //   )
  // }

  validInput(data: any) {
    if (data) {
      this.dataRequiredForDocumentUpload = data;
      this.previousDataOfGeneratingInput = data;
      this.dataRequiredForDocumentUpload.browserId = this.browserId;
      this.dataRequiredForDocumentUpload.requestToken = this.requestToken;
      this.navigateToTab(2);
    }
  }

  navigateToTab(index){
    this.setActiveTab(index);
    this.selectedTab = index;
  }

  documentUploaded(data: any) {
    if (data && data.isDocumentUploaded) {
      this.resetToInitialStage();
    }
  }

  enableOnlineGenerateInputTab(claimSubmissionData:any) {
    this.previousDataOfGeneratingInput = claimSubmissionData;
    this.navigateToTab(1);
  }

  productTypeChange(data: any) {
    this.resetDocuments = data;
  }

  resetIsParentTabSelectionChangeValue() {
    this.isParentTabSelectionChange = false;
  }

  resetChildComponentForms(isResettable: any) {
    if (isResettable) {
      this.resetToInitialStage();
    }
  }

  resetToInitialStage(){
    this.navigateToTab(0);
    this.resetData();
    this.resetTabsToInitialStage();
  }

  resetData(){
    this.dataRequiredForDocumentUpload = null;
    this.dataRequiredForGeneratingInput = null;
    this.previousDataOfGeneratingInput = null;
    this.browserId = null;
    this.requestToken = null;
    this.enrolId = null;
    this.isParentTabSelectionChange = false;
  }

  onTabClick(index){
    if(index != 2)
      this.selectedTab = index;

    if(index == 1 || index == 3)
      this.setInActiveTab(2)
  }
}
